import {
  clearGetAllMembers,
  clearGetMemberById,
  deleteMember,
  getAllMembers,
  getMemberById,
  updateMember,
  cancelMembership,
  extendMembership,
  retryPaymentMembership,
  deleteMemberProfile,
  retrySubscriptionPayment,
} from "./MembersActions";
import { createSlice } from "@reduxjs/toolkit";

interface MembersState {
  members: any[] | null;
  membersLoading: boolean;
  membersError: any | null;

  updateMember: any | null;
  updateMemberLoading: boolean;
  updateMemberError: any | null;

  deleteMember: any | null;
  deleteMemberLoading: boolean;
  deleteMemberError: any | null;

  memberById: any | null;
  memberByIdLoading: boolean;
  memberByIdError: any | null;

  cancelMembership: any | null;
  cancelMembershipLoading: boolean;
  cancelMembershipError: any | null;

  extendMembership: any | null;
  extendMembershipLoading: boolean;
  extendMembershipError: any | null;

  retryPaymentMembership: any | null;
  retryPaymentMembershipLoading: boolean;
  retryPaymentMembershipError: any | null;

  deleteMemberProfile: any | null;
  deleteMemberProfileLoading: boolean;
  deleteMemberProfileError: any | null;

  retrySubscriptionPaymentData: any | null;
  retrySubscriptionPaymentLoading: boolean;
  retrySubscriptionPaymentError: any | null;
}

const initialState: MembersState = {
  members: null,
  membersLoading: false,
  membersError: null,

  updateMember: null,
  updateMemberLoading: false,
  updateMemberError: null,

  deleteMember: null,
  deleteMemberLoading: false,
  deleteMemberError: null,

  memberById: null,
  memberByIdLoading: false,
  memberByIdError: null,

  cancelMembership: null,
  cancelMembershipLoading: false,
  cancelMembershipError: null,

  extendMembership: null,
  extendMembershipLoading: false,
  extendMembershipError: null,

  retryPaymentMembership: null,
  retryPaymentMembershipLoading: false,
  retryPaymentMembershipError: null,

  deleteMemberProfile: null,
  deleteMemberProfileLoading: false,
  deleteMemberProfileError: null,

  retrySubscriptionPaymentData: null,
  retrySubscriptionPaymentLoading: false,
  retrySubscriptionPaymentError: null,
};

const membersSlice = createSlice({
  name: "members",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAllMembers.pending, (state) => {
      state.membersLoading = true;
      state.membersError = null;
      state.members = null;
    });
    builder.addCase(getAllMembers.fulfilled, (state, action) => {
      state.membersLoading = false;
      state.members = action.payload;
      state.membersError = null;
    });
    builder.addCase(getAllMembers.rejected, (state, action) => {
      state.membersLoading = false;
      state.membersError = action.payload;
      state.members = null;
    });
    builder.addCase(updateMember.pending, (state) => {
      state.updateMemberLoading = true;
      state.updateMemberError = null;
    });
    builder.addCase(updateMember.fulfilled, (state, action) => {
      state.updateMemberLoading = false;
      state.updateMemberError = null;
      state.updateMember = action.payload;
    });
    builder.addCase(updateMember.rejected, (state, action) => {
      state.updateMemberLoading = false;
      state.updateMemberError = action.payload;
      state.updateMember = null;
    });
    builder.addCase(deleteMember.pending, (state) => {
      state.deleteMemberLoading = true;
      state.deleteMemberError = null;
    });
    builder.addCase(deleteMember.fulfilled, (state, action) => {
      state.deleteMemberLoading = false;
      state.deleteMemberError = null;
      state.deleteMember = action.payload;
    });
    builder.addCase(deleteMember.rejected, (state, action) => {
      state.deleteMemberLoading = false;
      state.deleteMemberError = action.payload;
      state.deleteMember = null;
    });
    builder.addCase(getMemberById.pending, (state) => {
      state.memberByIdLoading = true;
      state.memberByIdError = null;
    });
    builder.addCase(getMemberById.fulfilled, (state, action) => {
      state.memberByIdLoading = false;
      state.memberByIdError = null;
      state.memberById = action.payload;
    });
    builder.addCase(getMemberById.rejected, (state, action) => {
      state.memberByIdLoading = false;
      state.memberByIdError = action.payload;
      state.memberById = null;
    });

    builder.addCase(clearGetMemberById.fulfilled, (state) => {
      state.memberByIdLoading = false;
      state.memberByIdError = null;
      state.memberById = null;
    });

    builder.addCase(clearGetAllMembers.fulfilled, (state) => {
      state.membersLoading = false;
      state.membersError = null;
      state.members = null;
    });
    builder.addCase(cancelMembership.pending, (state) => {
      state.cancelMembershipLoading = true;
      state.cancelMembershipError = null;
      state.cancelMembership = null;
    });
    builder.addCase(cancelMembership.fulfilled, (state, action) => {
      state.cancelMembershipLoading = false;
      state.cancelMembershipError = null;
      state.cancelMembership = action.payload;
    });
    builder.addCase(cancelMembership.rejected, (state, action) => {
      state.cancelMembershipLoading = false;
      state.cancelMembershipError = action.payload;
      state.cancelMembership = null;
    });
    builder.addCase(extendMembership.pending, (state) => {
      state.extendMembershipLoading = true;
      state.extendMembershipError = null;
      state.extendMembership = null;
    });
    builder.addCase(extendMembership.fulfilled, (state, action) => {
      state.extendMembershipLoading = false;
      state.extendMembershipError = null;
      state.extendMembership = action.payload;
    });
    builder.addCase(extendMembership.rejected, (state, action) => {
      state.extendMembershipLoading = false;
      state.extendMembershipError = action.payload;
      state.extendMembership = null;
    });
    builder.addCase(retryPaymentMembership.pending, (state) => {
      state.retryPaymentMembershipLoading = true;
      state.retryPaymentMembershipError = null;
      state.retryPaymentMembership = null;
    });
    builder.addCase(retryPaymentMembership.fulfilled, (state, action) => {
      state.retryPaymentMembershipLoading = false;
      state.retryPaymentMembershipError = null;
      state.retryPaymentMembership = action.payload;
    });
    builder.addCase(retryPaymentMembership.rejected, (state, action) => {
      state.retryPaymentMembershipLoading = false;
      state.retryPaymentMembershipError = action.payload;
      state.retryPaymentMembership = null;
    });
    builder.addCase(deleteMemberProfile.pending, (state) => {
      state.deleteMemberProfileLoading = true;
      state.deleteMemberProfileError = null;
      state.deleteMemberProfile = null;
    });
    builder.addCase(deleteMemberProfile.fulfilled, (state, action) => {
      state.deleteMemberProfileLoading = false;
      state.deleteMemberProfileError = null;
      state.deleteMemberProfile = action.payload;
    });
    builder.addCase(deleteMemberProfile.rejected, (state, action) => {
      state.deleteMemberProfileLoading = false;
      state.deleteMemberProfileError = action.payload;
      state.deleteMemberProfile = null;
    });

    builder.addCase(retrySubscriptionPayment.pending, (state) => {
      state.retrySubscriptionPaymentLoading = true;
      state.retrySubscriptionPaymentError = null;
      state.retrySubscriptionPaymentData = null;
    });
    builder.addCase(retrySubscriptionPayment.fulfilled, (state, action) => {
      state.retrySubscriptionPaymentLoading = false;
      state.retrySubscriptionPaymentError = null;
      state.retrySubscriptionPaymentData = action.payload;
    });
    builder.addCase(retrySubscriptionPayment.rejected, (state, action) => {
      state.retrySubscriptionPaymentLoading = false;
      state.retrySubscriptionPaymentError = action.payload;
      state.retrySubscriptionPaymentData = null;
    });
  },
});

const membersReducer = membersSlice.reducer;

export default membersReducer;
